import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import React from "react";
function ColorWidget(props) {
  var disabled = props.disabled,
    readonly = props.readonly,
    BaseInput = props.registry.widgets.BaseInput;
  return React.createElement(BaseInput, _extends({
    type: "color"
  }, props, {
    disabled: disabled || readonly
  }));
}
if (process.env.NODE_ENV !== "production") {}
export default ColorWidget;